// reportListAtoms.js
import { atom } from 'recoil';

// Existing atoms for filters, page, and limit
export const reportListFilter = atom({
    key: 'reportListFilter',
    default: {
        mail_type: '',
        selected_status: '',
        created_date: '',
        date_sent: ''
    },
});

export const reportListPage = atom({
    key: 'reportListPage',
    default: 1,
});

export const reportListLimit = atom({
    key: 'reportListLimit',
    default: 25,
});


// New atom for search
export const reportListSearch = atom({
    key: 'reportListSearch',
    default: '',
});
// New atom for search
export const reportListTemplate = atom({
    key: 'reportListTemplate',
    default: '',
});

// New atom for search
export const reportListSubject = atom({
    key: 'reportListSubject',
    default: '',
});

